import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SwiperButton = (props) => {
    const btnClass = classNames('SwiperButton', props.inverted ? 'up' : 'down');

    return (
        <div className={btnClass}>
            <span /><span />
            <button onClick={props.onClick} />
        </div>
    );
};

SwiperButton.propTypes = {
    onClick: PropTypes.func,
    inverted: PropTypes.bool
};

SwiperButton.defaultProps = {
    onClick: fn => fn,
    inverted: false
};

export default SwiperButton;
